module.exports = __webpack_public_path__ + "img/login-oneid.fbaebd8e.svg";